import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { getPublicClient } from '@wagmi/core';
import { ClipboardService } from 'ngx-clipboard';
import { ToastrService } from 'ngx-toastr';
import { formatEther } from 'viem';
import { ITransactionDetails } from '../../Helper/helper';
import { WebStorageService } from '../../services/web-storage.service';
import { AppkitService } from 'src/app/shared/services/appkit.service';
import { getExplorerBaseUrl } from '../../utils/explorer-url.util';
import { NgIf, NgFor, NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ReadableDatePipe } from '../../pipes/readable-date.pipe';
import { UiTerminologyPipe } from '../../pipes/ui-terminology.pipe';


import { ImageFallbackDirective } from '../../directives/image-fallback.directive';
import { PinataThumbnailPipe } from 'src/app/shared/pipes/pinata-thumbnail.pipe';
interface ITxDetails {
  gasPrice: number;
  blockNumber: number;
}

@Component({
    selector: 'app-transaction-details-modal',
    templateUrl: './transaction-details-modal.component.html',
    styleUrls: ['./transaction-details-modal.component.css'],
    imports: [PinataThumbnailPipe, ImageFallbackDirective, NgIf, NgFor, NgClass, RouterLink, ReadableDatePipe, UiTerminologyPipe]
})
export class TransactionDetailsModalComponent {
  @Input() transactionModalData: ITransactionDetails;
  @Output() closeModal = new EventEmitter();
  transhUrl: string = '';
  account: any;
  publicClient: any = getPublicClient(this.appkitService.adapter.wagmiConfig );
  public txDetails: ITxDetails = {
    gasPrice: 0,
    blockNumber: 0,
  }
  public isRegulated: boolean = false;
  imageLoading = true;

  /**
   * Creates an instance of transaction details modal component.
   * @param webStorageService
   */
  constructor(
    private webStorageService: WebStorageService,
    private clibboard: ClipboardService,
    private toast: ToastrService,
    private appkitService: AppkitService
  ) {
    this.transactionModalData = this.getDefaultTransactionDetails();
  }

  /**
   * on init
   */
  ngOnInit() {
    this.account = this.webStorageService.getLocalStorage('account') != null ? JSON.parse(this.webStorageService.getLocalStorage('account') || '') : this.account;
    this.transhUrl = getExplorerBaseUrl(this.account?.chainId);
    this.isRegulated = JSON.parse(this.webStorageService.getLocalStorage('regulated') || 'true');
  }

  /**
   * Gets default transaction details
   * @param [overrides]
   * @returns default transaction details
   */
  getDefaultTransactionDetails(overrides?: Partial<ITransactionDetails>): ITransactionDetails {
    const defaultDetails: ITransactionDetails = {
      activeNft: '',
      transactionHash: '',
      contractAddress: '',
      operationName: '',
      operationStatus: 0,
      transactionTime: '',
      errorMessage: '',
      nfts: [
        {
          _id: '',
          name: '',
          primary_media: '',
          collectionAddress: '',
          secondary_media: []
        }
      ]
    };

    return { ...defaultDetails, ...overrides };
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (this.transactionModalData?.transactionHash) {
      const txData: any = await this.publicClient?.getTransaction({
        hash: this.transactionModalData?.transactionHash
      })
      const gasInWei: any = formatEther(txData?.gasPrice);
      this.txDetails = {
        gasPrice: gasInWei,
        blockNumber: txData?.blockNumber
      }
    }
  }

  /**
   * Sets active nft
   * @param index
   */
  setActiveNft(index: number) {
    this.transactionModalData.activeNft = this.transactionModalData.nfts[index];
  }

  /**
   * Closes transaction modal
   */
  closeTransactionModal() {
    this.transactionModalData = this.getDefaultTransactionDetails();
    this.txDetails = {
      gasPrice: 0,
      blockNumber: 0
    }
    this.closeModal.emit();
  }

  /**
   * Adjusts the tooltip size based on the content height.
   * 
   */
  public setTooltipSize() {
    (<HTMLElement>document.getElementById(`tooltip-title`)).classList.remove('add-content');
    const contentHeight = (<HTMLElement>document.getElementById(`tooltip-title`)).scrollHeight;
    (<HTMLElement>document.getElementById(`tooltip-title`)).classList.add('add-content');
    if (contentHeight > 59) {
      (<HTMLElement>document.getElementById(`tooltip-head`)).classList.add('tooltip-details');
    }
    else {
      (<HTMLElement>document.getElementById(`tooltip-head`)).classList.remove('tooltip-details')
    }
  }

  /**
   * Copies the provided address to the clipboard
   *
   * @param {string} address - The address to be copied to the clipboard.
   */
  copyAddress(address: string) {
    this.clibboard.copy(address);
    this.toast.success('Address copied successfully.');
  }

}
